import { GetOrdersResponse } from './types';
import { SetPickToursPayload } from '../actions/orders.types';
import { OrderType } from '../../types';

export const mapGetOrdersResponseToSetPickToursPayload = (response: GetOrdersResponse): SetPickToursPayload => {
  const transformedOrdersByType = Object.entries(response.ordersByType || {}).reduce<
    SetPickToursPayload['pickToursByType']
  >((acc, [orderTypeKey, group]) => {
    const orderType = orderTypeKey as OrderType;
    if (group) {
      acc[orderType] = {
        orders: [],
        pickTours: group.pickTours,
        errorPickTours: group.errorPickTours || [],
        sortOrder: group.sortOrder,
      };
    }
    return acc;
  }, {});

  return {
    pickToursByType: transformedOrdersByType,
  };
};
